import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import SortModal from "./SortModal";
import ProjectCard from "./ProjectCard";
import SortButton from "./SortButton";
import { filterProjects } from "./Filter";

function Projects() {
  const [repos, setRepos] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [sortType, setSortType] = useState("");
  const [filterType, setFilterType] = useState("");

  useEffect(() => {
    fetch("https://api.github.com/users/sertacgltkn/repos")
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        return data.map((repo) => ({
          ...repo,
          image_url: "https://picsum.photos/400",
          hidden: false,
        }));
      })
      .then((data) => {
        data.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        setRepos(data);
      })
      .catch((error) => console.log(error));
  }, []);

  const toggleHide = (repoId) => {
    setRepos(
      repos.map((repo) =>
        repo.id === repoId ? { ...repo, hidden: !repo.hidden } : repo
      )
    );
  };

  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const sortProjects = (type) => {
    setSortType(type);

    const sortedRepos = [...repos];

    if (type === "az") {
      sortedRepos.sort((a, b) => a.name.localeCompare(b.name));
    } else if (type === "za") {
      sortedRepos.sort((a, b) => b.name.localeCompare(a.name));
    } else if (type === "newest") {
      sortedRepos.sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      );
    } else if (type === "oldest") {
      sortedRepos.sort(
        (a, b) => new Date(a.created_at) - new Date(b.created_at)
      );
    }

    setRepos(sortedRepos);
  };

  const handleFilterProjects = (type) => {
    setFilterType(type);
    filterProjects(type, repos, setRepos);
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <motion.h1
        className="text-4xl font-bold m-4 text-slate-50"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        My Projects
      </motion.h1>

      <motion.div className="flex justify-between mb-4">
        <SortButton openModal={openModal} />
        <div className="space-x-2">
          <button
            className={`rounded-md px-3 py-2 text-sm font-medium ${
              filterType === "javascript" ? "bg-yellow-300" : "bg-gray-100"
            }`}
            onClick={() => handleFilterProjects("javascript")}
          >
            JavaScript
          </button>
          <button
            className={`rounded-md px-3 py-2 text-sm font-medium ${
              filterType === "css" ? "bg-blue-400" : "bg-gray-100"
            }`}
            onClick={() => handleFilterProjects("css")}
          >
            CSS
          </button>
          <button
            className={`rounded-md px-3 py-2 text-sm font-medium ${
              filterType === "vue" ? "bg-green-300" : "bg-gray-100"
            }`}
            onClick={() => handleFilterProjects("vue")}
          >
            Vue
          </button>
          <button
            className={`rounded-md px-3 py-2 text-sm font-medium ${
              filterType === "scss" ? "bg-pink-300" : "bg-gray-100"
            }`}
            onClick={() => handleFilterProjects("scss")}
          >
            SCSS
          </button>
          <button
            className={`rounded-md px-3 py-2 text-sm font-medium ${
              filterType === "" ? "bg-gray-300" : "bg-gray-100"
            }`}
            onClick={() => handleFilterProjects("")}
          >
            All
          </button>
        </div>
      </motion.div>

      <motion.div
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.4 }}
      >
        {repos
          .filter((repo) => !repo.hidden)
          .map((repo) => (
            <ProjectCard repo={repo} toggleHide={toggleHide} key={repo.id} />
          ))}
      </motion.div>

      {showModal && (
        <SortModal
          sortType={sortType}
          closeModal={closeModal}
          sortProjects={sortProjects}
        />
      )}
    </div>
  );
}

export default Projects;